var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.773438,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#117DF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.2737L21.5 15.2737M8 24.7737H12L22.5 14.2737C22.7626 14.0111 22.971 13.6993 23.1131 13.3561C23.2553 13.013 23.3284 12.6452 23.3284 12.2737C23.3284 11.9023 23.2553 11.5345 23.1131 11.1913C22.971 10.8482 22.7626 10.5364 22.5 10.2737C22.2374 10.0111 21.9256 9.80276 21.5824 9.66061C21.2392 9.51847 20.8714 9.44531 20.5 9.44531C20.1286 9.44531 19.7608 9.51847 19.4176 9.66061C19.0744 9.80276 18.7626 10.0111 18.5 10.2737L8 20.7737V24.7737Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.047e731265a7a3695bea72adadf06a5c.svg";
export { ForwardRef as ReactComponent };